import {Button, Card, Stack, styled, Typography} from '@mui/material';

const StyledContainer = styled(Card)`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	box-shadow: none;
	padding-block: 16px;
	padding-right: 16px;

	${({theme}) => theme.breakpoints.down('sm')} {
		flex-direction: column;
		align-items: flex-start;
		padding-left: 16px;
		padding-right: 0px;
		gap: 12px;
	}
`;

const StyledContentMobile = styled(Stack)`
	flex-direction: row;
	width: 100%;
	gap: 12px;
`;

const StyledButtonMobile = styled(Button)`
	width: fit-content;
`;

const StyledContainerText = styled(Stack)`
	width: 100%;
	padding-left: 12px;
	padding-right: 16px;
	${({theme}) => theme.breakpoints.down('sm')} {
		padding: 0;
		gap: 12px;
	}
`;

const StyledTitle = styled(Typography)`
	color: ${({theme}) => theme.colors.light.primary.main};
	font-weight: 600;
`;
const StyledDescription = styled(Typography)`
	color: ${({theme}) => theme.colors.light.text.primary};
	font-size: 14px;
`;

const StyledImageContainer = styled(Stack)`
	width: 56px;
	height: 56px;
	-moz-transform: scaleX(-1);
	-o-transform: scaleX(-1);
	-webkit-transform: scaleX(-1);
	transform: scaleX(-1);

	${({theme}) => theme.breakpoints.down('sm')} {
		width: 111px;
		height: 111px;
		-moz-transform: scaleX(1);
		-o-transform: scaleX(1);
		-webkit-transform: scaleX(1);
		transform: scaleX(1);
	}
`;

export {
	StyledContainer,
	StyledContentMobile,
	StyledButtonMobile,
	StyledContainerText,
	StyledTitle,
	StyledDescription,
	StyledImageContainer,
};
